import { useEffect, useState } from 'react';

const STORAGE_KEY = 'darkMode';

// The choice saved by the theme switch, else the OS preference.
const readInitialDarkMode = () => {
  const saved = localStorage.getItem(STORAGE_KEY);
  if (saved !== null) return saved === 'true';
  return window.matchMedia('(prefers-color-scheme: dark)').matches;
};

/**
 * The app's theme: `.dark` on <html> follows `darkMode`, saved on every change. Whichever top
 * bar is mounted (Insights' Topbar or PULSE's own) owns it, so a page reached directly gets it too.
 */
const useDarkMode = () => {
  const [darkMode, setDarkMode] = useState(readInitialDarkMode);

  useEffect(() => {
    document.documentElement.classList.toggle('dark', darkMode);
    localStorage.setItem(STORAGE_KEY, darkMode);
  }, [darkMode]);

  const toggleDarkMode = () => setDarkMode((current) => !current);

  return { darkMode, toggleDarkMode };
};

export default useDarkMode;
